(function () {
    'use strict';

    angular
        .module('vm')
        .factory('MetricsDataService', MetricsDataService);

    function MetricsDataService ($cookies) {

        const COOKIE_NAME = 'mrcs';

        return {
            getAllData: getAllData,
            getCampaign: getCampaign,
        };

        //////////////

        function getAllData() {
            const value = $cookies.get(COOKIE_NAME);

            return value ? value.split('|') : null;
        }

        function getCampaign() {
            const data = getAllData();

            return data ? data[1] : null;
        }
    }
}());